import React from "react";
import { Link } from "react-router-dom";
import { TerraMatrixBrand } from "@/components/branding/TerraMatrixBrand";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-background flex">
      {/* Brand pane — visible on desktop */}
      <div className="hidden lg:flex lg:w-[480px] xl:w-[540px] relative flex-col justify-between overflow-hidden bg-primary/5 border-r border-border">
        {/* Grid motif background */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage:
              "linear-gradient(to right, hsl(var(--primary) / 0.06) 1px, transparent 1px), linear-gradient(to bottom, hsl(var(--primary) / 0.06) 1px, transparent 1px)",
            backgroundSize: "32px 32px",
            maskImage:
              "radial-gradient(ellipse 80% 70% at 50% 50%, black 20%, transparent 100%)",
            WebkitMaskImage:
              "radial-gradient(ellipse 80% 70% at 50% 50%, black 20%, transparent 100%)",
          }}
        />
        {/* Accent glow */}
        <div
          className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[400px] h-[300px] pointer-events-none opacity-40"
          style={{
            background:
              "radial-gradient(ellipse at center, hsl(var(--primary) / 0.25), transparent 70%)",
          }}
        />

        {/* Content */}
        <div className="relative z-10 flex flex-col h-full px-10 py-12">
          {/* Logo + brand */}
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <TerraMatrixBrand
              markClassName="h-8 w-8"
              nameClassName="text-lg"
            />
          </Link>

          {/* Headline */}
          <div className="flex-1 flex flex-col justify-center">
            <h1
              className="text-4xl xl:text-[42px] font-semibold leading-[1.08] tracking-tight text-foreground"
              style={{ letterSpacing: "-0.03em" }}
            >
              Build what the
              <br />
              physical world
              <br />
              <span className="text-primary">actually needs.</span>
            </h1>
            <p className="mt-5 text-[15px] leading-relaxed text-muted-foreground max-w-[360px]">
              Connect sensors, automate workflows, and deploy intelligent
              microapps — all from a visual canvas.
            </p>
          </div>

        </div>
      </div>

      {/* Form pane */}
      <div className="flex-1 flex items-center justify-center p-6 sm:p-8">
        <div className="w-full max-w-md">
          {/* Mobile-only brand header */}
          <div className="lg:hidden text-center mb-8">
            <Link to="/" className="inline-flex items-center gap-3 mb-3 hover:opacity-80 transition-opacity">
              <TerraMatrixBrand
                markClassName="h-8 w-8"
                nameClassName="text-xl"
              />
            </Link>
            <p className="text-muted-foreground text-sm">
              AI-Powered Component Editor
            </p>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};
